/* eslint-disable */
/*
  Polyfill for Event.composedPath() method for Chrome 38
  The composedPath() method was introduced later and is not available in older browsers
*/

// @ts-nocheck - This polyfill file intentionally bypasses type checking to fix Chrome 38 issues

declare global {
  interface Event {
    composedPath?(): EventTarget[];
  }
}

// Check if composedPath is already supported
if (typeof Event !== 'undefined' && Event.prototype && !Event.prototype.composedPath) {
  Event.prototype.composedPath = function () {
    const path: EventTarget[] = [];
    let target = this.target as Element;

    // If no target, return empty array
    if (!target) {
      return path;
    }

    // Add the target to the path
    path.push(target);

    // Walk up the DOM tree to build the event path
    while (target && target.parentNode) {
      target = target.parentNode as Element;
      path.push(target);
    }

    // Add window if we reached the document
    if (target && target === document) {
      path.push(window);
    }

    return path;
  };
}

export {}; // Make this file a module
